import { useState } from 'react'
import VisaCard from '@/src/components/common/visaCard'
import { Chip, Container, Spacer, Typography } from '@/src/ct-design/lib'
import { DeviceType } from '@/src/types'
import { DESKTOP } from '@/src/constants'
import { styleConfig } from '@/src/constants/visa/visaBookingsList'
import useBookingList from '@/src/hooks/useBookingList'
import VisaCardShimmer from '../../desktop/itinerary/loader/visaCardLoader'
import { CONFIRMED, REJECTED } from '@/src/constants/visa'

const VisaBookingsList = ({
    deviceType = DESKTOP
}: {
    deviceType: DeviceType
}) => {
    const { titleVariant, spacing, visaCardPadding } = styleConfig[deviceType]
    const { visaList, isLoading } = useBookingList()
    const [selectedTab, setSelectedTab] = useState<'UPCOMING' | 'COMPLETED'>(
        'UPCOMING'
    )

    const handleTabClick = (tab: 'UPCOMING' | 'COMPLETED') => {
        setSelectedTab(tab)
    }

    const filteredVisaList = visaList.filter((booking) => {
        if (selectedTab === 'COMPLETED') {
            return (
                booking.item.status === CONFIRMED ||
                booking.item.status === REJECTED
            )
        } else {
            return (
                booking.item.status !== CONFIRMED &&
                booking.item.status !== REJECTED
            )
        }
    })

    return (
        <Container className='mt-6'>
            <Typography variant={titleVariant}>
                Your Visa Application
            </Typography>
            <Spacer className={spacing} />
            <Container className='flex flex-middle'>
                <Chip
                    label='Upcoming'
                    onClick={() => handleTabClick('UPCOMING')}
                    isSelected={selectedTab === 'UPCOMING'}
                />
                <Spacer className='mr-2' />
                <Chip
                    label='Completed'
                    onClick={() => handleTabClick('COMPLETED')}
                    isSelected={selectedTab === 'COMPLETED'}
                />
            </Container>
            <Spacer className='mb-8' />
            <Container className='flex w-100p ox-scroll hide-scrollbar'>
                {isLoading ? (
                    <VisaCardShimmer
                        className={visaCardPadding}
                        titleVariant={titleVariant}
                    />
                ) : (
                    filteredVisaList.map((bookings) => (
                        <VisaCard
                            key={bookings.key}
                            bookings={bookings.item}
                            className={visaCardPadding}
                        />
                    ))
                )}
            </Container>
        </Container>
    )
}

export default VisaBookingsList
